module.exports = __webpack_public_path__ + "img/simi-thumbnails.fd0e4015.png";